var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogQuickInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1289 6.08643C12.1289 9.40013 9.44262 12.0864 6.12891 12.0864C2.8152 12.0864 0.128906 9.40013 0.128906 6.08642C0.128906 2.77272 2.8152 0.0864258 6.12891 0.0864258C9.44262 0.0864258 12.1289 2.77272 12.1289 6.08643ZM4.92891 2.7207V6.08639V9.45207V2.7207Z",
    fill: "#00AE31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12891 2.64941V6.42795L8.31912 8.61817",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogQuickInfoIcon);
export default __webpack_public_path__ + "static/media/log-quick-info-icon.c53d32fd2bcf6751cd9a9c687838e1c0.svg";
export { ForwardRef as ReactComponent };